import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "@/hooks/useAuth";
import { pointsApi, UserPoints } from "@/api/referral/points";
import { Coins } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useToast } from "@/hooks/use-toast";

export const PointsDisplay = () => {
  const { user } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [points, setPoints] = useState<UserPoints | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (user?.id) {
      loadPoints();
    }
  }, [user?.id]);

  const loadPoints = async () => {
    if (!user?.id) return;
    try {
      setIsLoading(true);
      const data = await pointsApi.getUserPoints(user.id);
      setPoints(data);
    } catch (error) {
      console.error("Failed to load points:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!user) return null;

  return (
    <button
      type="button"
      onClick={() => navigate("/referrals")}
      className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-gradient-to-r from-[#9b87f5]/10 to-[#7E69AB]/10 border border-[#9b87f5]/20 transition-colors hover:from-[#9b87f5]/20 hover:to-[#7E69AB]/20 cursor-pointer"
    >
      <Coins className="h-4 w-4 text-[#9b87f5]" />
      <span className="text-sm font-semibold text-[#7E69AB]">
        {isLoading ? "..." : points?.total_points || 0}
      </span>
    </button>
  );
};
